// extracted by mini-css-extract-plugin
module.exports = {"select":"_1W7hk_gGrZ6NqGGSyihlnA"};